export const WRAPPED_FN_KEY = '__wrappedFn__';
